

import { me as apiMe, users as apiUser } from '@/apis'
export default {
  namespaced:true,
  state : {
    userProfile:null,
    wallet: {},
    walletRefreshStatus:false
  },
  
  getters : {
    GETTERS_ME: (state) => state.userProfile || {},
    GETTERS_WALLET: (state) => state.wallet,
    GETTERS_WALLET_STATUS: (status) => status.walletRefreshStatus
  },
  
  mutations : {
    MUTATION_ME (state, data) { 
      state.userProfile = data
      if((data || {}).wallet){
        state.wallet = data.wallet 
      }
    },
    MUTATION_WALLET (state, data) {
      (state.userProfile || {}).wallet = data
      state.wallet = data
    },
    MUTATION_WALLET_STATUS (state, data) {
      state.walletRefreshStatus = data
    }
  },
  
  actions : {
    async ACTION_ME ({ state, commit },reload = false) {
      if (state.userProfile && !reload) return
      const [err,data] = await apiUser.getUserProfile()

      if(err){  
        return
      }
 
      commit('MUTATION_ME', data)
    },

    async ACTION_WALLET ({ rootState,commit }) {
      if(!rootState.auth.token) {
        return
      }
      
      commit('MUTATION_WALLET_STATUS',true) 
      const [err, data,] = await apiMe.getWallet()
      commit('MUTATION_WALLET_STATUS',false)
      
      if(err){ 
        return
      }
  
      commit('MUTATION_WALLET',data) 
    },
  }
} 